import { useScreen } from '@/hooks/useScreen';
import { convertQuantity } from 'common/quantityHelpers';
import { PostContext } from 'context/PostContext';
import { ButtonEmphasis, ButtonSize } from 'design-system/components/Button';
import Button from 'design-system/components/Button/Button';
import dynamic from 'next/dynamic';
import { useContext } from 'react';
import { PostInteractionGetterContext } from '../../provider/PostInteractionProvider';
import FloatingPostMenuHelper from './FloatingPostMenuHelper';

const Tooltips = dynamic(
  () => import('design-system/components/Tooltips/Tooltips')
);

const PostCommentButton = ({
  navigateGroup,
}: {
  navigateGroup: () => void;
}) => {
  const { isDesktop } = useScreen();

  const { commentCount } = useContext(PostInteractionGetterContext);
  const { isLocked } = useContext(PostContext);

  const buttonProps: {
    onClick: () => void;
    size: ButtonSize;
    emphasis: ButtonEmphasis;
  } = {
    onClick: () => {
      if (isLocked) {
        navigateGroup();
        return;
      }
      const a = document.createElement('a');
      a.href = '#comment_section';
      a.click();
      a.remove();
    },
    size: 'medium',
    emphasis: 'medium',
  };

  return (
    <>
      {isDesktop ? (
        <div>
          <Tooltips title={'Bình luận'}>
            <Button
              {...buttonProps}
              mode="icon-only"
              icon={{
                name: 'comment',
              }}
            />
          </Tooltips>
          <FloatingPostMenuHelper>
            {convertQuantity(commentCount)}
          </FloatingPostMenuHelper>
        </div>
      ) : (
        <Button
          {...buttonProps}
          mode="text-only"
          startIcon={{
            name: 'comment',
          }}
        >
          {convertQuantity(commentCount)}
        </Button>
      )}
    </>
  );
};

export default PostCommentButton;
